import { Injectable, Inject} from '@angular/core';

export  class PolicyCoverageInsuredAccessoryDO {
    public  id:Number = null;
	public  accessoryCd:String = null;
	public  description:String = null;
	public  selected:String = null;
    public  accessoryValue:DoubleRange=null;
	
	
	public  getId() {
		return this.id;
	}

	public  setId( id) {
		this.id = id;
	}
	
	public getAccessoryCd() {
		return this.accessoryCd;
	}

	public setAccessoryCd(accessoryCd:String) {
		this.accessoryCd = accessoryCd;
	}

	public getDescription() {
		return this.description;
	}

	public setDescription(description:String) {
		this.description = description;
	}

	public getAccessoryValue() {
		return this.accessoryValue;
	}

	public setAccessoryValue(accessoryValue:DoubleRange) {
		this.accessoryValue = accessoryValue;
	}

	public getSelected() {
		return this.selected;
	}

	public setSelected(selected:String) {
		this.selected = selected;
	}

}
